/**
 * 환경 인식 로거 유틸리티
 * - 개발 환경: console 출력
 * - 프로덕션: 에러만 출력 (warn/info/debug 무시)
 */
const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  error: (message: string, ...args: unknown[]) => {
    console.error(`[ERROR] ${message}`, ...args);
  },
  warn: (message: string, ...args: unknown[]) => {
    if (isDev) console.warn(`[WARN] ${message}`, ...args);
  },
  info: (message: string, ...args: unknown[]) => {
    if (isDev) console.info(`[INFO] ${message}`, ...args);
  },
  debug: (message: string, ...args: unknown[]) => {
    if (isDev) console.debug(`[DEBUG] ${message}`, ...args);
  },
};

export default logger;
